import EmptyAvatar from "@circle-assets/images/avatar-empty.png";
import { isNoNamePlaceholder } from "@circle-react-uikit/UserImage/isNoNamePlaceholder";
import {
  nameToHslColor,
  nameToInitials,
} from "@circle-react-uikit/UserImage/name";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCallback, useMemo, useState } from "react";

interface MemberCardImageProps {
  className?: string;
  name: string;
  src: string;
}

export const MemberCardImage = ({
  src,
  name,
  className,
}: MemberCardImageProps) => {
  const isUserWithoutName = isNoNamePlaceholder(name);
  const avatarName = isUserWithoutName ? "" : name;
  const imageSrc = isUserWithoutName && !src ? EmptyAvatar : src;
  const hasImage = Boolean(imageSrc);
  const [hasError, setHasError] = useState(false);

  const handleOnError = useCallback(() => {
    setHasError(true);
  }, []);

  const initials = useMemo(() => nameToInitials(avatarName), [avatarName]);

  const style = useMemo(
    () => ({ backgroundColor: nameToHslColor(avatarName) }),
    [avatarName],
  );

  const shouldShowImage = hasImage && !hasError;

  return (
    <div
      className="relative isolate block size-full object-cover"
      data-testid="user-profile"
    >
      {shouldShowImage && (
        <img
          loading="lazy"
          className={classNames(
            "absolute left-0 top-0 z-10 size-full rounded-t-xl object-cover",
            className,
          )}
          src={imageSrc}
          onError={handleOnError}
          alt={avatarName}
        />
      )}
      <div
        className={classNames(
          "z-10 flex size-full items-center justify-center rounded-t-xl text-lg font-medium tracking-normal text-white",
          {
            invisible: shouldShowImage,
          },
          className,
        )}
        style={style}
      >
        {initials}
      </div>
    </div>
  );
};
